/**
 * Simple view for choosing items and then adding them to a list.
 */

var _ = require('underscore');
var sw = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');
var ShapewaysView = require('./ShapewaysView');
var optionsTemplate = require('rrTags/product/templates/tpl.list-chooser-option.mustache');

var DEFAULTS = {
  OPTIONS_TEMPLATE_NAME: 'defaultTemplate',
  SELECTED_OPTIONS_PROP: 'defaultSelectedOptions',
  ALL_OPTIONS_PROP: 'defaultAllOptions'
};

var NEW_OPTION_ID_PREFIX = 'tempId';

var NEW_OPTION_INIT_ID = '-1';

var selectedOptionTemplates = {
  materialChooser: function (callback) {
    require(['rrTags/product/templates/tpl.material-chooser-selected-option.mustache'], callback);
  },

  variantChooser: function (callback) {
    require(['rrTags/product/templates/tpl.variant-chooser-selected-option.mustache'], callback);
  },

  mergeProductChooser: function(callback) {
    require(['rrTags/product/templates/tpl.merge-product-chooser-selected-option.mustache'], callback);
  }
};

selectedOptionTemplates[DEFAULTS.OPTIONS_TEMPLATE_NAME] = function (callback) {
  require(['rrTags/product/templates/tpl.list-chooser-selected-option.mustache'], callback);
};

var ListChooserView = ShapewaysView.extend({
  swAttrs: {
    selectedOptionsContainer:   'data-sw-list-chooser-selected-options-container',
    removeButtons:              'data-sw-list-chooser-remove',
    select:                     'data-sw-list-chooser-select',
    selectOption:               'data-sw-list-chooser-select-option',
    selectOptionId:             'data-sw-list-chooser-select-option-id',
    selectedOptionId:           'data-sw-list-chooser-selected-option-id',
    selectedOptionCustomInput:  'data-sw-list-chooser-selected-option-custom',
    clickItem:                  'data-sw-list-chooser-click-item',
    clickItemInput:             'data-sw-list-chooser-click-item-input',
    clickOptionId:              'data-sw-list-chooser-click-item-id'
  },

  events: function events() {
    var eventHandlers = {};

    eventHandlers['change ' + this.swSelectors.select] = 'onSelect';
    eventHandlers['click ' + this.swSelectors.removeButtons] = 'onRemove';
    eventHandlers['change ' + this.swSelectors.selectedOptionCustomInput] = 'onSelectedOptionInputChange';
    eventHandlers['click ' + this.swSelectors.clickItem] = 'onClick';

    return eventHandlers;
  },

  initialize: function(options) {

    // set to default if they're missing
    options.selectedOptionsModelProp = _.isEmpty(options.selectedOptionsModelProp) ? DEFAULTS.SELECTED_OPTIONS_PROP : options.selectedOptionsModelProp;
    options.selectedOptionTemplateName = _.isEmpty(options.selectedOptionTemplateName) ? DEFAULTS.OPTIONS_TEMPLATE_NAME : options.selectedOptionTemplateName;
    options.selectedOptionTplPropMaps = options.selectedOptionTplPropMaps || {};
    options.selectedOptionTplPropMaps.name = options.selectedOptionTplPropMaps.name || 'name';
    options.selectedOptionTplPropMaps.value = options.selectedOptionTplPropMaps.value || 'value';
    options.selectedOptionTplPropMaps.optionId = options.selectedOptionTplPropMaps.optionId || 'optionId';

    // Adds options derived from attributes to the map for rendering.
    var additionalOptions = options.dataAttrMap;
    if (!_.isEmpty(additionalOptions)) {
      _.mapObject(additionalOptions, function(mappedDataAttribute, modelAttributeKey) {
        if (modelAttributeKey) {
          options.selectedOptionTplPropMaps[modelAttributeKey] = modelAttributeKey;
        }
      });
    }

    var _self = this;
    var selectOptTemplateFetcher = selectedOptionTemplates[options.selectedOptionTemplateName];

    // This fetches the options template
    selectOptTemplateFetcher(function initAfterTemplate(selectedOptionTemplate) {
      _self.selectedOptionTemplate = selectedOptionTemplate;
      _self.state.set({
        inputName:                  _self.cachedElements.$select.attr('name'),
        selectActionType:           options.selectActionType,
        deselectActionType:         options.deselectActionType,
        allOptionsModelProp:        DEFAULTS.ALL_OPTIONS_PROP,
        selectedOptionsModelProp:   options.selectedOptionsModelProp,
        selectedOptionTplPropMaps:  options.selectedOptionTplPropMaps,
        currentOptionsModelProp:    options.currentOptionsModelProp,
        disabledClass:              options.disabledClass,
        dataAttrMap:                options.dataAttrMap
      });

      // Remove the attribute off the select so only the dynamic inputs are tracked
      _self.cachedElements.$select.removeAttr('name');

      if (!options.model) {
        _self.model = _self.state;
        _self.initOptions();
        _self.initSelectedOptions();
      }

      if (options.selectedOptionsModelProp) {
        _self.listenTo(_self.model, 'change:' + options.selectedOptionsModelProp, _self.repaint, _self);
      }

      if (options.currentOptionsModelProp) {
        _self.listenTo(_self.model, 'change:' + options.currentOptionsModelProp, _self.updateDropdown, _self);
      }
    });

    // Event listener to handle when the chooser part of ListChooser gets updated dynamically (usually via Ajax)
    if (options.chooserUpdatedEvent) {
      this.listenTo(sw, options.chooserUpdatedEvent, this.updateClickChooser);
    }
  },

  initOptions: function () {
    // Set the default options to be the the text and value of each option from the select
    var defaultOptionMap = _.reduce(this.cachedElements.$selectOption, function (defOptionMap, optionEl) {
      var $optionEl = $(optionEl);
      var optionsHash = {
        optionId: $optionEl.attr(this.swAttrs.selectOptionId),
        name: $optionEl.text(),
        value: $optionEl.val()
      };

      var additionalOptions = this.model.get('dataAttrMap');
      if (!_.isEmpty(additionalOptions)) {
        _.mapObject(additionalOptions, function(mappedDataAttribute, modelAttributeKey) {
          if (modelAttributeKey) {
            optionsHash[modelAttributeKey] = $optionEl.attr(mappedDataAttribute);
          }
        });
      }

      defOptionMap.push(optionsHash);
      return defOptionMap;
    }, [], this);
    this.model.set(this.state.get('allOptionsModelProp'), defaultOptionMap);
  },

  initSelectedOptions: function () {
    var selectedOptions = _.reduce(this.cachedElements.$selectedOptionId, function (selectOptionMap, selectedOptionIdEl) {
      var $selectedOptionIdEl = $(selectedOptionIdEl);
      var option = this.getOptionFromSelf($selectedOptionIdEl.attr(this.swAttrs.selectedOptionId));
      var optionsHash = {
        optionId: option.optionId,
        name: option.name,
        value: option.value
      };

      var additionalOptions = this.model.get('dataAttrMap');
      if (!_.isEmpty(additionalOptions)) {
        _.mapObject(additionalOptions, function(mappedDataAttribute, modelAttributeKey) {
          if (modelAttributeKey) {
            optionsHash[modelAttributeKey] = option[modelAttributeKey];
          }
        });
      }

      selectOptionMap.push(optionsHash);
      return selectOptionMap;
    }, [], this);
    this.model.set(this.state.get('selectedOptionsModelProp'), selectedOptions);
  },

  usesInternalStateOnly: function() {
    return this.model === this.state;
  },

  getOptionFromSelf: function (optionId) {
    var options = this.model.get(this.state.get('allOptionsModelProp'));
    return _.findWhere(options, { optionId: optionId});
  },

  removeOption: function (optionId) {
    var listProp = this.state.get('selectedOptionsModelProp');
    var selectedOptions = this.model.get(listProp);
    var newOptions = _.reject(selectedOptions, function(option) {
      return option.optionId === optionId;
    });
    this.model.set(listProp, newOptions);
  },

  addOption: function (optionId) {
    var listProp = this.state.get('selectedOptionsModelProp');
    var selectedOptions = this.model.get(listProp);

    var optionAlreadyAdded = _.findWhere(selectedOptions, {
      optionId: optionId
    });

    if (_.isEmpty(optionAlreadyAdded)) {
      var newOption = this.getOptionFromSelf(optionId);
      if(optionId === NEW_OPTION_INIT_ID) {
        newOption = {name: newOption.name, value: '', optionId: _.uniqueId(NEW_OPTION_ID_PREFIX + '_')};
      }
      var newOptions = selectedOptions.concat([newOption]);
      this.model.set(listProp, newOptions);
    }
  },

  onSelect: function(e) {

    var actionType = this.state.get('selectActionType');
    var $select = $(e.target);
    var value = $select.val();
    var optionId = $select.find('option[value="'+value+'"]').attr(this.swAttrs.selectOptionId);

    // If the select has a value dispatch the add action
    if (optionId) {

      if (actionType) {
        this.fireSelectAction(actionType, optionId);
      }

      if(this.usesInternalStateOnly()) {
        this.addOption(optionId);
      }

      // and reset to default value
      $select.val([]).change();
    }

    e.preventDefault();
  },

  /**
   * Updates the chooser for when it's populated with new options.
   */
  updateClickChooser: function updateClickChooser() {
    var disabledClass = this.state.get('disabledClass');

    var selectedOptions = this.model.get(this.state.get('selectedOptionsModelProp'));

    this.cacheSwSelectors();

    _.each(selectedOptions, function(option) {
      this.cachedElements.$selectOption.filter('[' + this.swAttrs.clickOptionId + '="' + option.optionId + '"]').addClass(disabledClass);
    }, this);

    this.initOptions();
  },

  /**
   * Handles click events in the list (for when not using a dropdown).
   *
   * @param e event object
   */
  onClick: function(e) {
    var actionType = this.state.get('selectActionType');
    var $clickedItem = $(e.currentTarget);
    var optionId = $clickedItem.attr(this.swAttrs.clickOptionId);

    // If the select has a value dispatch the add action
    if (optionId) {

      if (actionType) {
        this.fireSelectAction(actionType, optionId);
      }

      if(this.usesInternalStateOnly()) {
        this.addOption(optionId);
      }
    }

    e.preventDefault();
  },

  onRemove: function(e) {

    var optionId = $(e.target).attr(this.swAttrs.selectedOptionId);
    var actionType = this.state.get('deselectActionType');

    if(actionType) {
      this.fireDeselectAction(actionType, optionId);
    }

    if(this.usesInternalStateOnly()) {
      this.removeOption(optionId);
    }

    e.preventDefault();
  },

  //for editable selected options, this will update the stored state to match the typed value of the input
  onSelectedOptionInputChange: function(e) {
    var $changedInput = $(e.target);
    var changedInputOptionId = $changedInput.siblings('[' + this.swAttrs.selectedOptionId + ']').attr(this.swAttrs.selectedOptionId);
    var listProp = this.state.get('selectedOptionsModelProp');
    var selectedOptions = this.model.get(listProp);

    var matchingOptionIndex = _.findIndex(selectedOptions, function(option) {
      return option.optionId === changedInputOptionId;
    });

    selectedOptions[matchingOptionIndex].value = $changedInput.val();
    selectedOptions[matchingOptionIndex].name = $changedInput.val();


    this.model.set(listProp, selectedOptions);

    e.preventDefault();
  },

  fireSelectAction: function fireSelectAction(actionType, optionId) {
    var actionCreators = this.model.getActionCreators();
    if (actionCreators.listChooserSelectAction) {
      sw.dispatch(actionCreators.listChooserSelectAction(actionType, optionId));
    }
  },

  fireDeselectAction: function fireDeselectAction(actionType, optionId) {
    var actionCreators = this.model.getActionCreators();
    if (actionCreators.listChooserDeselectAction) {
      sw.dispatch(actionCreators.listChooserDeselectAction(actionType, optionId));
    }
  },

  /**
   * Populates the select with new dropdown options based on the model prop provided.
   */
  updateDropdown: function() {
    var currentOptions = this.model.get(this.state.get('currentOptionsModelProp'));
    if (!_.isEmpty(currentOptions)) {
      var options = '<option></option>';

      _.each(currentOptions, function(option) {
        options += optionsTemplate.render({
          optionId: option.id,
          title:    option.title
        });
      });

      this.cachedElements.$select.html(options);

      // This is commented out because we can hopefully rely on Minimalect's Mutation Observer Code.
      // It that's not true, we uncomment this line
      // this.cachedElements.$select.minimalect('update');

      // updates cachedElements with the new options.
      this.cacheSwSelectors();
    }
  },

  /**
   * Repaint the list of selected options
   */
  render: function() {
    var selectedOptions = this.model.get(this.state.get('selectedOptionsModelProp'));
    var optionPropMaps = this.state.get('selectedOptionTplPropMaps');
    var html = '';

    var disabledClass = this.state.get('disabledClass');

    this.cachedElements.$selectOption.prop('disabled', false);
    this.cachedElements.$selectOption.removeClass(disabledClass);

    _.each(selectedOptions, function(selectedOption) {

      // Map option data to view data
      var renderOptions = _.reduce(optionPropMaps, function (renderOptions, modelKey, viewKey) {
        renderOptions[viewKey] = selectedOption[modelKey];
        return renderOptions;
      }, {});

      renderOptions.inputName = this.state.get('inputName');
      html += this.selectedOptionTemplate.render(renderOptions);

      // Filter the chooser depending on whether it uses a select dropdown or listens to clicks on elements
      if (!this.cachedElements.$clickItem.length) {
        this.cachedElements.$selectOption.filter('[value="' + renderOptions.value + '"]').prop('disabled', true);
      } else {
        this.cachedElements.$selectOption.filter('[' + this.swAttrs.clickOptionId + '="' + renderOptions.optionId + '"]').addClass(disabledClass);
      }

    }, this);

    // This is commented out because we can hopefully rely on Minimalect's Mutation Observer Code.
    // It that's not true, we uncomment this line
    // this.cachedElements.$select.minimalect('update');
    this.cachedElements.$selectedOptionsContainer.html(html);
  }

});

module.exports = ListChooserView;
